// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination_5319cca0 {
  display: flex;
}
.pagination_inline_5319cca0 {
  display: inline-flex;
}
.pagination__button_5319cca0 {
  display: flex;
  flex-direction: row;
  margin: 0 0.167rem;
}
.pagination__button_small_5319cca0 {
  margin: 0;
  min-width: 2rem;
  padding: 0 0.334rem;
  justify-content: space-around;
}
.pagination__prev_5319cca0 {
  display: flex;
  margin-right: 0.334rem;
}
.pagination__prev_small_5319cca0 {
  margin-left: 0.334rem;
  margin-right: 0.167rem;
}
.pagination__next_5319cca0 {
  display: flex;
  margin-left: 0.334rem;
}
.pagination__next_small_5319cca0 {
  margin-left: 0.167rem;
  margin-right: 0.334rem;
}
.pagination__navigation-button_small_5319cca0 {
  padding: 0 0.334rem;
}
.pagination__navigation-button_5319cca0:disabled {
  background-color: transparent !important;
  color: #c1c8cd !important;
  text-shadow: none !important;
  box-shadow: none !important;
}
.pagination__go-to-page_5319cca0 {
  margin-left: 1.334rem;
}
.pagination__separator_5319cca0 {
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  margin: 0 0.334rem;
  height: 2.667rem;
  min-width: 2.667rem;
}
.pagination__separator_small_5319cca0 {
  height: 2rem;
  min-width: 2rem;
  margin: 0 0.167rem;
}
.pagination__separator_5319cca0::before {
  content: '...';
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `pagination_5319cca0`,
	"pagination_inline": `pagination_inline_5319cca0`,
	"pagination__button": `pagination__button_5319cca0`,
	"pagination__button_small": `pagination__button_small_5319cca0`,
	"pagination__prev": `pagination__prev_5319cca0`,
	"pagination__prev_small": `pagination__prev_small_5319cca0`,
	"pagination__next": `pagination__next_5319cca0`,
	"pagination__next_small": `pagination__next_small_5319cca0`,
	"pagination__navigation-button_small": `pagination__navigation-button_small_5319cca0`,
	"pagination__navigation-button": `pagination__navigation-button_5319cca0`,
	"pagination__go-to-page": `pagination__go-to-page_5319cca0`,
	"pagination__separator": `pagination__separator_5319cca0`,
	"pagination__separator_small": `pagination__separator_small_5319cca0`
};
export default ___CSS_LOADER_EXPORT___;
